import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore";
import { Action } from "@opstel/query/v2/models/action";
import React, { useMemo } from "react";
import { Layer } from "react-konva";
import { StablingInfraLookup } from "@opstel/query/models/location";
import { StandingTrains, TrackActionWithShuntingUnit } from "@opstel/EPD/components/StandingTrains";
import { ShuntingUnit } from "@opstel/query/models/shuntingUnit";
import {
  MovementActionWithTracksAndGeometry,
  TrainMovement,
} from "@opstel/EPD/components/TrainMovement";

export interface TrainLayerProps {
  readonly stablingInfra: StablingInfraLookup;
  readonly actions: Action[];
  readonly shuntingUnits: Record<string, ShuntingUnit>;
}

export function TrainLayer({
  stablingInfra,
  actions,
  shuntingUnits,
}: TrainLayerProps): React.JSX.Element {
  const currentTime = useSelectedTimeStore((state) => state.selectedTime)!;
  const enrichedActions = useMemo(
    () =>
      actions
        .map((action) => Action.enrichWithShuntingUnit(action, shuntingUnits))
        .map((actionWithShuntingUnit) =>
          Action.enrichWithInfra(actionWithShuntingUnit, stablingInfra),
        ),
    [actions, shuntingUnits, stablingInfra],
  );
  const activeActions = enrichedActions.filter((action) => Action.isActiveAt(action, currentTime));

  return (
    <Layer>
      {activeActions.filter(Action.isMoveAction).map((action) => (
        <TrainMovement
          key={action.id}
          action={action as unknown as MovementActionWithTracksAndGeometry}
        />
      ))}
      {activeActions.filter(Action.isSingleTrackAction).map((action) => (
        <StandingTrains key={action.id} action={action as unknown as TrackActionWithShuntingUnit} />
      ))}
    </Layer>
  );
}
